import React from "react";
import Select from "../../../form/Select";
import Button from "../../../form/Button";
import Icon from "../../../form/Icon";
import QueryBuilder, {fields} from "./QueryBuilder/QueryBuilder";

const queryFields = [...fields, {
    name: 'optin',
    label: 'OptIn',
    operators: [
        {
            name: '=',
            label: '='
        },
        {
            name: '!=',
            label: '!='
        },
    ],
    valueEditor: (props) => {
        return <Select
            component="OptIn"
            storeType="local"
            placeholder="OptIn"
            label={false}
            value={props.value}
            objectValue={false}
            saveChanges={(field, value) => {
                props.handleOnChange(value);
            }}
        />;
    }
}];

export default class OptInSubscriberFilter extends React.Component {

    constructor(props) {
        super(props);
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }


    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }

    render() {
        const filter = JSON.parse(JSON.stringify(this.props.value || {
            filters: [],
            operator: "OR"
        }));
        const paramsProps = {
            name: this.props.name,
            value: filter,
            saveChanges: (field, value) => {
                this.props.saveChanges(field, value);
            }
        };
        return (
            <div className="row">
                <div className="col-md-12">
                    <QueryBuilder {...paramsProps} fields={queryFields} />
                </div>
            </div>
        );
    }
}